import * as tokens from '@cash-design-system/tokens'

/** Targets device width >= 760px */
const tablet = `@media (min-width: ${tokens.BreakpointSmall})` as const

/**
 * Targets device width >= 1024px
 * @deprecated Try to avoid using this breakpoint and opt for tablet breakpoint instead since tablet = desktop
 */
const desktop = `@media (min-width: ${tokens.BreakpointMedium})` as const

/** Targets device width >= 1440px */
const widescreen = `@media (min-width: ${tokens.BreakpointLarge})` as const

const breakpoints = {
  /** Targets device width >= 760px */
  tablet,
  /**
   * Targets device width >= 1024px
   * @deprecated Try to avoid using this breakpoint and opt for tablet breakpoint instead since tablet = desktop.
   * This can still be used if absolutely necessary for legacy reasons
   */
  desktop,
  /** Targets device width >= 1440px */
  widescreen,
} as const

export type ThemeBreakpoints = typeof breakpoints

export default breakpoints
